import React, { useState } from "react";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import TipoClienteSelect from "./TipoClienteSelect";


export const FiltroClientesEspeciales = ({ onExecute, msgTitulo }) => {
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState({
    tipo: "",
  });
  const onOpenModal = () => {
    const container = document.getElementById("mdlFiltros-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  const onCargar = () => {
    onExecute(state.tipo)
    onOpenModal();
  };

  return (
    <div className="plantilla-screen-filtro">
      <div
        className="plantilla-screen-filtro-button-modal"
        onClick={onOpenModal}
      >
        <FilterAltIcon /> Filtrar
      </div>
      <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
        <PlantillaScreen
          titulo={`Filtro`}
          className_main={1}
          className={"plantilla-screen-filtro-container-modal"}
        >
          <div className="plantilla-screen-filtro-container-modal-container">
            <TipoClienteSelect
              value={state.tipo}
              onChange={(tipo) => setState({ ...state, tipo })}
              className="plantilla-screen-filtro-container-modal-container-linea"
            />
            <div className="plantilla-screen-filtro-container-modal-modal-acciones">
              <div
                className="plantilla-screen-filtro-container-modal-modal-acciones-cancelar"
                onClick={onOpenModal}
              >
                Cancelar
              </div>
              <div
                className="plantilla-screen-filtro-container-modal-modal-acciones-guardar"
                onClick={onCargar}
              >
                Cargar
              </div>
            </div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};
